import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { SplitFactor } from "./SplitFactor";
import { SplitRate } from "./SplitRate";
import { deepExtend } from "../../../../Utils/Utils";
export var Split = /*#__PURE__*/function () {
  function Split() {
    _classCallCheck(this, Split);
    this.count = 1;
    this.factor = new SplitFactor();
    this.rate = new SplitRate();
    this.sizeOffset = true;
  }
  _createClass(Split, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.count !== undefined) {
        this.count = data.count;
      }
      this.factor.load(data.factor);
      this.rate.load(data.rate);
      if (data.particles !== undefined) {
        this.particles = deepExtend({}, data.particles);
      }
      if (data.sizeOffset !== undefined) {
        this.sizeOffset = data.sizeOffset;
      }
    }
  }]);
  return Split;
}();